import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { getViewsEngRate } from '../SearchContentTable.utils';
import { TextCell } from '../components/TextCell';

export const ColumnViewEngRate: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'viewEngRate',
    cell: ({ row }) => <TextCell>{getViewsEngRate(row.original)}</TextCell>,
    header: () => <>View Eng Rate</>,
  });
